import Api from '@/misc/api'
import type { Commit } from '@/misc/types'
import type { RumAdditionalCodingsPayloadDto, UpdateStayStatusResponseDto } from '@/stay-list/stay-quick-view/store/dto'
import { StayStatusEnum } from '@/store/modules/stay/types'

// Routed through Api.post (like groupageSimulation.ts): a failure (e.g. a ManualBulkCodingException,
// or the stay already validated) already surfaces a toast with the backend's message via Api.post
// itself — this wrapper only resolves/rejects so the caller can reset its own loading state, per
// BUILD-807 (aside left as-is, no partial UI update, on error).
export function updateMcoStayStatus(
  stayId: number,
  status: StayStatusEnum.VALIDATED,
  additionalCodings: RumAdditionalCodingsPayloadDto[],
  commit: Commit
): Promise<UpdateStayStatusResponseDto> {
  return new Promise((resolve, reject) => {
    Api.post(
      {
        url: '/api/stays/mco/update-status',
        body: { stayId, status, additionalCodings },
        successMut: (data: UpdateStayStatusResponseDto) => resolve(data),
        errorMut: () => reject(new Error(`Failed to update stay status (stay ${stayId})`)),
      },
      commit
    )
  })
}
